import type { ClientGroupFlagRequest } from '@DigitaleDoerfer/digitale-doerfer-api';

import { useGrapevineGroupEventsApi } from '@/features/api/hooks/grapevine-group-events/useGrapevineGroupEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const useFlagGroup = () => {
  const api = useGrapevineGroupEventsApi();

  return useApiMutation({
    mutationFn: (clientGroupFlagRequest: ClientGroupFlagRequest) =>
      api.onChatFlagRequest({ clientGroupFlagRequest })
  });
};
